/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Field, Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import { API_URL, ROLES } from '../../../../utils/constants';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import CustomersApi from '../../../../services/api/CustomersApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import AutocompleteComponent from '../../../../components/common/forms/Autcomplete/AutocompleteComponent';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import styled from 'styled-components';
import CheckboxInputComponent from '~/src/components/common/forms/CheckboxInput/CheckboxInputComponent';
import { ContractorUniquenessRequestDto } from '~/src/types/GetContractorDuplicateDto';
import { ContractorUniquenessResponseDto } from '~/src/types/ContractorDuplicateInfoDto';
import ContractorsApi from '~/src/services/api/ContractorsApi';
import DuplicateCheckModal from '~/src/components/common/contractors/DuplicateCheckModal';
import AutocomplitePaginatedComponent from '~/src/components/common/forms/Autcomplete/AutocomplitePaginatedComponent';
import RolesDependent from '~/src/components/common/RolesDependent';

export default function CustomerEdit(): JSX.Element {
  const { id } = useParams();
  const [isChecked, setIsChecked] = useState(false);
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  };
  const [itemData, setItemData] = useState({
    name: '',
    isFromBulgaria: false,
    countryId: '',
    address: '',
    uniqueCompanyNumber: '',
    dataArrived: false,
    svilaClientId: '',
  });
  const history = useHistory();

  const uniquenessCheck = async (values: ContractorUniquenessRequestDto, setFieldValue: any) => {
    values.entityType = 'Customer';
    let result = null;

    if (id) {
      result = await ContractorsApi.isUniqueForUpdate('Customer', id, values);
    } else {
      result = await ContractorsApi.isUniqueForCreate(values);
    }

    if (result?.status === StatusCodes.OK) {
      const resultData: ContractorUniquenessResponseDto = result.data;
      setModalMessage(resultData.message);
      setIsModalOpen(true);

      if (resultData.isPossibleToCreateContractor) {
        setIsSaveButtonEnabled(true);
      } else {
        setIsSaveButtonEnabled(false);
      }

      setFieldValue('contractorId', resultData.contractorId);
    }
  }

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let result = null;

    if (id) {
      result = await CustomersApi.update(id, values);
    } else {
      result = await CustomersApi.create(values);
    }

    if (result.status === StatusCodes.OK) {
      history.push('/customers');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const result = await CustomersApi.get(id);
    const newItemData = { ...result.data, dataArrived: true, address: result.data?.contractor?.address, uniqueCompanyNumber: result.data?.contractor?.uniqueCompanyNumber };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        onLeftHandler={() => {
          history.push(`/customers`);
        }}
        title={`${id ? 'Edit ' : 'Create '} Customer`}
      />
      {id && itemData.dataArrived === false ? null : (
        <Formik
          initialValues={{
            name: itemData.name,
            countryId: itemData.contractor?.country?.id || '',
            address: itemData.address,
            uniqueCompanyNumber: itemData.uniqueCompanyNumber,
            contractorId: '',
            isFromBulgaria: itemData.isFromBulgaria,
            svilaClientId: itemData.svilaClientId || '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            return saveItem(values, setSubmitting);
          }}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, errors }) => (
            <FormWrapper>
              <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '440px' }}>
                <FormRow>
                  <TextInputComponent
                    name="name"
                    label="Name"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={(event) => {
                      handleChange(event);
                      setIsSaveButtonEnabled(false);
                    }}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <AutocomplitePaginatedComponent
                    url={`${API_URL}/countries/get`}
                    name="countryId"
                    label='Country'
                    initialValue={values.countryId}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                      setIsSaveButtonEnabled(false);
                    }}
                    getOptionLabel={(option) => `${option.name}`}
                    errorMessage={errors.countryId}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <TextInputComponent
                    name="address"
                    label="Address"
                    value={values.address}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <TextInputComponent
                    name="uniqueCompanyNumber"
                    label="Unique Company Number (VAT)"
                    value={values.uniqueCompanyNumber}
                    onBlur={handleBlur}
                    onChange={(event) => {
                      handleChange(event);
                      setIsSaveButtonEnabled(false);
                    }}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <CheckboxInputComponent
                    label=" Bulgarian Client"
                    name="isFromBulgaria"
                    onChange={handleClick}
                    checked={isChecked}
                    cols={12}
                  />
                </FormRow>
                <RolesDependent
                  roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]}>
                  <FormRow>
                    <AutocomplitePaginatedComponent
                      url={`${API_URL}/svila-clients/get-all`}
                      name="svilaClientId"
                      initialValue={values.svilaClientId}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                      getOptionLabel={(option) => `${option.name}`}
                      errorMessage={errors.svilaClientId}
                      cols={12}
                      label="Svila Client"
                    />
                  </FormRow>
                </RolesDependent>
                <ActionWrapper>
                  <PrimaryButton
                    variant="primary"
                    isSubmitting={isSubmitting}
                    type="button"
                    title="Check for duplicates"
                    onClick={() => uniquenessCheck(values, setFieldValue)}
                    disabled={!values.name || !values.countryId || !values.uniqueCompanyNumber}
                  />
                  <PrimaryButton
                    variant="primary"
                    isSubmitting={isSubmitting}
                    type="submit"
                    title="Save"
                    disabled={!isSaveButtonEnabled} />
                </ActionWrapper>
              </form>
            </FormWrapper>
          )}
        </Formik>
      )}
      <DuplicateCheckModal
        isOpen={isModalOpen}
        message={modalMessage}
        onClose={() => setIsModalOpen(false)}
      />
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
